var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5404 16.2251L18.0194 13.7041C17.8193 13.4982 17.5697 13.347 17.2944 13.2652C17.0191 13.1834 16.7275 13.1736 16.4473 13.2369C16.1672 13.3001 15.908 13.4342 15.6946 13.6263C15.4812 13.8185 15.3206 14.0622 15.2284 14.3341C15.0845 14.7232 14.8046 15.0469 14.4404 15.2455C14.0762 15.444 13.6524 15.504 13.2474 15.4141C12.1707 15.0265 11.1929 14.406 10.3838 13.5968C9.5746 12.7876 8.95405 11.8098 8.56641 10.7331C8.45679 10.3271 8.50812 9.89449 8.70971 9.52541C8.91129 9.15634 9.24757 8.87932 9.64841 8.75214C9.92037 8.65991 10.1641 8.4994 10.3562 8.28597C10.5484 8.07254 10.6825 7.81334 10.7457 7.53322C10.8089 7.25309 10.7992 6.96142 10.7173 6.68616C10.6355 6.41089 10.4844 6.16124 10.2784 5.96114L7.75641 3.44114C7.42453 3.13728 6.99088 2.96875 6.54092 2.96875C6.09095 2.96875 5.6573 3.13728 5.32541 3.44114L3.61541 5.15114C1.90441 6.95114 3.79541 11.7231 8.02641 15.9511C12.2574 20.1791 17.0264 22.1631 18.8264 20.3621L20.5374 18.6511C20.8403 18.3199 21.0085 17.8875 21.009 17.4387C21.0096 16.9899 20.8424 16.5571 20.5404 16.2251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11);
export default __webpack_public_path__ + "static/media/Frame (11).4f61ad1e.svg";
export { ForwardRef as ReactComponent };